import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-coockie-consent',
  templateUrl: './coockie-consent.component.html',
  styleUrls: ['./coockie-consent.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonicModule
  ]
})
export class CoockieConsentComponent {

}
